import { stdObject } from "../../../../data/types/stdObject";
import { toPrice } from "../../../../utils/toPrice";

export const writeRecordsReport = ({
  t,
  id,
  searchValues,
  responseReportData,
}: stdObject) => {
  let results = [];
  try {
    results = JSON.parse(responseReportData.list);
  } catch (error) {
    console.log("writeRecordsReport error 0: ", error);
    let dataRepaired = responseReportData.list
      .replace(/},\n([a-zA-Z])"/g, '},\n{"$1"')
      .replaceAll("}{", "},{")
      .replace(/(\d)\{/g, "$1}]},{")
      .replace(/,"([a-zA-Z]+)\{/g, ',"$1":""},{')
      .replace(/},\n([a-zA-Z])"/g, '},\n{"$1"')
      .replaceAll(':{"type"', ':""}},{"type"')
      .replace(/(\p{L})\{/gu, '$1"},{');
    try {
      results = JSON.parse(dataRepaired);
    } catch (error) {
      console.log("writeRecordsReport error 1: ", error);
    }
  }
  try {
    results.forEach((e: stdObject, index: number) => {
      if ("data" in e) {
        e.data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
      }
      results[index] = e;
    });
  } catch (error) {
    console.log("writeRecordsReport error 2: ", error);
  }

  try {
    results = results
      .sort((a: stdObject, b: stdObject) =>
        typeof a.date === "string" && typeof b.date === "string"
          ? b.date.localeCompare(a.date)
          : a.date - b.date,
      )
      .map((e: stdObject) => {
        let name = e.name ?? "";
        if (e.type === "din" && name !== "") {
          const parts = name.split(".");
          if (parts.length === 2) {
            name = t("c." + name.split(".")[0]) + " " + name.split(".")[1];
          }
        } else if (e.observ === "paymentsRecorded") {
          let recordRows: stdObject[] = [];
          Object.entries(e.data).forEach((v: [string, any]) => {
            v[0] !== "payTypes" &&
              v[1].forEach((o: stdObject) => {
                if (v[0] === "delete") {
                  recordRows.push([
                    e.data.payTypes?.[o.TIPDIN] ?? o.TIPDIN,
                    toPrice(o.CANDIN),
                    t("r.deleted"),
                  ]);
                } else {
                  let tempValues: string[] = [];
                  ["TIPDIN", "CANDIN"].forEach((m: string) => {
                    let value = o.find((h: any[]) => h[0] === m)?.[1];
                    if (m === "TIPDIN" && e.data.payTypes?.[value]) {
                      value = e.data.payTypes[value];
                    }
                    tempValues.push(m === "CANDIN" ? toPrice(value) : value);
                  });
                  tempValues.push(
                    v[0] === "insert" ? t("r.added") : t("r.updated"),
                  );
                  recordRows.push(tempValues);
                }
              });
          });
          name = recordRows;
        }
        return {
          ...e,
          type: e.type.toLowerCase(),
          typeName:
            typeof e.type === "string"
              ? t(
                  `c.${e.type.toUpperCase() === "PRE" ? "PREP" : e.type.toUpperCase()}`,
                )
              : e.type,
          userName: `(${e.userCode}) ${e.userName}`,
          name,
          action: t(`r.${e.observ}`),
        };
      });
  } catch (error) {
    console.error("writeRecordsReport error 3: ", error);
  }
  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results,
    },
  };
};
